export default function ReportsPage() {
    return (
        <div className="min-h-screen bg-secondary-50 p-8">
            <h1 className="mb-6">Reports</h1>
            <div className="card">
                <p className="text-secondary-600">Reports and analytics - Coming soon</p>
            </div>
        </div>
    );
}
